import { AuthorCard, Body, Description } from './AuthorCard';
import { Avatar, Name } from './AuthorCard.views';
AuthorCard.displayName = "AuthorCardBase";
Avatar.displayName = "AuthorCard.Avatar";
Body.displayName = "AuthorCard.Body";
Name.displayName = "AuthorCard.Name";
Description.displayName = "AuthorCard.Description";
export { AuthorCard as default, Body, Avatar, Name, Description };